module.exports = __webpack_public_path__ + "media/squishiland-1.9f8e3568.mp4";